import {Button, Card, Col, DatePicker, Form, Icon, Input, Modal, Row, Select, Spin, Table, Tooltip} from 'antd';
import React, {Component} from 'react';
import {getFormFieldByType, sanitizeFieldName} from '../../util/methods';
import moment from 'moment';
import DocumentList from '../../components/DocumentList';
import MasterModal from "../../components/MasterModal";
import FieldSearchForm from "../../components/FieldSearchForm";

const {TextArea} = Input;
let assetTableDataSource = [];

class Create extends Component {
  constructor(props) {
    super(props);

    this.id = 0;
    this.balanceRequestSignatures = {};

    this.state = {
      documentData: [],
      keys: [],
      selectedSpares: {},
      fromLocation: props.data && props.data.from && props.data.from.location ? props.data.from.location._id : null,
      fromClient: props.data && props.data.from && props.data.from.client ? props.data.from.client._id : null,
      dispatchedDate: props.data && props.data.dispatchedDate ? moment(props.data.dispatchedDate) : null,
      balancePopup: {visible: false, loading: false, rows: []},
    };
  }

  componentDidMount() {
    const {match, fetch, data} = this.props;
    if(match.params && match.params.id) {
      fetch(match.params.id);
    }

    this.setState({
      keys: data && data.spareParts && data.spareParts.length > 0 ? data.spareParts : [{}],
      selectedSpares: this.getSelectedSpares(data && data.spareParts),
    });
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.data && nextProps.data.spareParts && JSON.stringify(nextProps.data.spareParts) !== JSON.stringify(this.props.data.spareParts)) {
      this.setState({
        keys: nextProps.data.spareParts,
        selectedSpares: this.getSelectedSpares(nextProps.data.spareParts),
        fromLocation: nextProps.data.from && nextProps.data.from.location ? nextProps.data.from.location._id : null,
        fromClient: nextProps.data.from && nextProps.data.from.client ? nextProps.data.from.client._id : null,
        dispatchedDate: nextProps.data.dispatchedDate ? moment(nextProps.data.dispatchedDate) : null,
      });
    }
  }

  getSelectedSpares = (spareParts = []) => {
    return (spareParts || []).reduce((selectedSpares, sparePart, index) => {
      const spareId = sparePart && sparePart.sparePart && (sparePart.sparePart._id || sparePart.sparePart);
      if(spareId) {
        selectedSpares[index] = spareId;
      }
      return selectedSpares;
    }, {});
  };

  getAvailableQuantityFieldName = (index) => `spareParts[${index}]['availableQuantity']`;

  getQuantityFieldName = (index) => `spareParts[${index}]['quantity']`;

  setAvailableQuantity = (index, quantity = 0) => {
    this.props.form.setFields({
      [this.getAvailableQuantityFieldName(index)]: {
        value: quantity,
      }
    });
  };

  getAvailableQuantityFromBalance = (balance = [], client) => {
    const selectedClient = client ? client.toString() : null;
    const matchedBalance = (balance || []).find(item => item._id === selectedClient);
    return matchedBalance ? matchedBalance.total : 0;
  };

  revalidateQuantity = (index) => {
    const fieldName = this.getQuantityFieldName(index);
    if(this.props.form.getFieldValue(fieldName) !== undefined) {
      this.props.form.validateFields([fieldName], {force: true}, () => {
      });
    }
  };

  refreshAvailableQuantity = async (index, spareId, overrides = {}) => {
    const location = Object.prototype.hasOwnProperty.call(overrides, 'fromLocation') ? overrides.fromLocation : this.state.fromLocation;
    const client = Object.prototype.hasOwnProperty.call(overrides, 'fromClient') ? overrides.fromClient : this.state.fromClient;
    const dispatchedDate = Object.prototype.hasOwnProperty.call(overrides, 'dispatchedDate') ? overrides.dispatchedDate : this.state.dispatchedDate;

    if(!spareId || !location || !dispatchedDate || !this.props.getSpareInventoryBalance) {
      this.setAvailableQuantity(index, 0);
      this.revalidateQuantity(index);
      return;
    }

    const requestSignature = [
      spareId,
      location,
      client || 'null',
      moment(dispatchedDate).valueOf(),
    ].join(':');

    this.balanceRequestSignatures[index] = requestSignature;

    try {
      const balance = await this.props.getSpareInventoryBalance({
        spare: spareId,
        location,
        date: dispatchedDate,
        subLocation: client || undefined,
      });

      if(this.balanceRequestSignatures[index] !== requestSignature) {
        return;
      }

      this.setAvailableQuantity(index, this.getAvailableQuantityFromBalance(balance, client));
      this.revalidateQuantity(index);
    } catch (error) {
      if(this.balanceRequestSignatures[index] === requestSignature) {
        this.setAvailableQuantity(index, 0);
        this.revalidateQuantity(index);
      }
    }
  };

  refreshAllAvailableQuantities = (overrides = {}) => {
    Object.keys(this.state.selectedSpares).forEach((key) => {
      this.refreshAvailableQuantity(parseInt(key, 10), this.state.selectedSpares[key], overrides);
    });
  };

  // Shows balance as on dispatched date: selected sub location only, or all sub locations of the location
  showBalancePopup = async (index) => {
    const {fromLocation, fromClient, dispatchedDate, selectedSpares} = this.state;
    const spareId = selectedSpares[index];
    if(!spareId || !fromLocation || !dispatchedDate) {
      return;
    }

    const popup = {
      visible: true,
      loading: true,
      rows: [],
      date: dispatchedDate,
      hasSubLocation: !!fromClient,
    };
    this.balancePopupRequest = popup;
    this.setState({balancePopup: popup});

    let rows = [];
    try {
      const balance = await this.props.getSpareInventoryBalance({
        spare: spareId,
        location: fromLocation,
        date: dispatchedDate,
        subLocation: fromClient || undefined,
      });
      rows = (balance || []).filter(item => !fromClient || item._id === fromClient.toString());
    } catch (error) {
      // error message is already shown by the action
    }

    if(this.balancePopupRequest === popup) {
      this.setState({balancePopup: {...popup, loading: false, rows}});
    }
  };

  closeBalancePopup = () => {
    this.balancePopupRequest = null;
    this.setState({balancePopup: {visible: false, loading: false, rows: []}});
  };

  renderBalancePopup() {
    const {balancePopup} = this.state;
    const rows = balancePopup.rows || [];
    const total = rows.reduce((sum, row) => sum + (parseFloat(row.total) || 0), 0);
    const columns = [
      {
        title: 'Sub Location',
        dataIndex: 'name',
        key: 'name',
        render: (name, row) => (row._id ? name : 'No Sub Location'),
      },
      {title: 'Balance', dataIndex: 'total', key: 'total', align: 'right'},
    ];

    return (
      <Modal
        title={`Balance as on ${balancePopup.date ? moment(balancePopup.date).format('DD-MM-YYYY HH:mm') : ''}`}
        visible={balancePopup.visible}
        onCancel={this.closeBalancePopup}
        footer={null}
        width={420}
        destroyOnClose
      >
        <Table
          size="small"
          rowKey={row => row._id || 'no-sub-location'}
          columns={columns}
          dataSource={rows}
          loading={balancePopup.loading}
          pagination={false}
          locale={{emptyText: 'No balance found'}}
          footer={!balancePopup.hasSubLocation && rows.length > 1 ? () => <b>Total: {total}</b> : undefined}
        />
      </Modal>
    );
  }

  remove = index => {
    const {keys, selectedSpares} = this.state;
    const {form, filters} = this.props;
    const item = filters['spareParts'];
    if(keys.length === 1) {
      return;
    }

    const val = form.getFieldValue('spareParts');
    val.splice(index, 1);
    keys.splice(index, 1);

    for (let i = 0; i < val.length; i++) {
      Object.keys(item.schema).map((itm) => {
        form.setFieldsValue({
          [`spareParts[${i}]['${itm}']`]: val[i][itm],
        });
      });
    }

    const newSelectedSpares = {};
    Object.keys(selectedSpares).forEach((key) => {
      const keyIndex = parseInt(key, 10);
      if(keyIndex < index) {
        newSelectedSpares[keyIndex] = selectedSpares[key];
      } else if(keyIndex > index) {
        newSelectedSpares[keyIndex - 1] = selectedSpares[key];
      }
    });

    delete this.balanceRequestSignatures[index];

    this.setState({
      keys: keys,
      selectedSpares: newSelectedSpares,
    });
  };

  add = () => {
    const field = 'spareParts';
    const {keys} = this.state;
    keys.push(`${field}${this.id++}`);
    this.setState({
      keys: keys,
    });
  };

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if(err) {
        return console.log(err);
      }

      // Validate spare quantities before submission
      const spareParts = values.spareParts || [];
      let hasQuantityError = false;

      spareParts.forEach((spare, index) => {
        const availableQty = parseFloat(spare.availableQuantity) || 0;
        const requestedQty = parseFloat(spare.quantity) || 0;

        if (availableQty <= 0) {
          this.props.form.setFields({
            [`spareParts[${index}]['quantity']`]: {
              value: spare.quantity,
              errors: [new Error('Available quantity is 0. Cannot transfer this spare.')],
            }
          });
          hasQuantityError = true;
        } else if (requestedQty > availableQty) {
          this.props.form.setFields({
            [`spareParts[${index}]['quantity']`]: {
              value: spare.quantity,
              errors: [new Error(`Quantity cannot exceed available quantity (${availableQty})`)],
            }
          });
          hasQuantityError = true;
        } else if (requestedQty <= 0) {
          this.props.form.setFields({
            [`spareParts[${index}]['quantity']`]: {
              value: spare.quantity,
              errors: [new Error('Quantity must be greater than 0')],
            }
          });
          hasQuantityError = true;
        }
      });

      if (hasQuantityError) {
        return;
      }

      const {documentData} = this.state;
      const data = Object.assign({}, values);
      if(documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData;
      }

      if(match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        this.props.onSubmit(data);
      }
    });
  };

  getDocumentData = (data) => {
    this.setState({documentData: data});
  };

  handleFromLocationChange = (location) => {
    this.setState({
      fromLocation: location,
    }, () => {
      this.refreshAllAvailableQuantities({fromLocation: location});
    });
  };

  handleFromClientChange = (client) => {
    this.setState({
      fromClient: client || null,
    }, () => {
      this.refreshAllAvailableQuantities({fromClient: client || null});
    });
  };

  handleDispatchedDateChange = (date) => {
    this.setState({
      dispatchedDate: date || null,
    }, () => {
      this.refreshAllAvailableQuantities({dispatchedDate: date || null});
    });
  };

  handleSparePartSelect = (index, spare) => {
    this.setState((prevState) => ({
      selectedSpares: {
        ...prevState.selectedSpares,
        [index]: spare,
      }
    }), () => {
      this.refreshAvailableQuantity(index, spare);
    });
  };

  validateQuantity = (index) => (rule, value, callback) => {
    const {form} = this.props;
    const availableQty = parseFloat(form.getFieldValue(`spareParts[${index}]['availableQuantity']`)) || 0;
    const requestedQty = parseFloat(value) || 0;

    if (availableQty <= 0) {
      callback('Available quantity is 0. Cannot transfer this spare.');
    } else if (requestedQty > availableQty) {
      callback(`Quantity cannot exceed available quantity (${availableQty})`);
    } else if (requestedQty <= 0) {
      callback('Quantity must be greater than 0');
    } else {
      callback();
    }
  }

  formItems() {
    const {form, filters, title, resource} = this.props;
    const {getFieldDecorator, setFieldsValue} = form;
    const {keys, fromLocation, dispatchedDate, selectedSpares} = this.state;
    const canSelectSparePart = !!(fromLocation && dispatchedDate);

    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
    };
    return keys.map((k, index) => {

      return <div key={index} style={style}>

        <FieldSearchForm
          title={title}
          otherDetails={{title, resource, setFieldsValue}}
          options={filters['spareParts'] && filters['spareParts']['schema'] && filters['spareParts']['schema']['sparePart'].options}
          key={'sparePart'}
          name={`spareParts[${index}]['sparePart']`}
          label={
            <span>Spare Part&nbsp;
              <Tooltip title="View balance as on dispatched date">
                <Button
                  size="small"
                  icon="eye"
                  style={{marginBottom: 0}}
                  disabled={!canSelectSparePart || !selectedSpares[index]}
                  onClick={() => this.showBalancePopup(index)}
                />
              </Tooltip>
            </span>
          }
          message={`Spare Part is required`}
          required={true}
          disabled={title === 'EDIT' || !canSelectSparePart}
          field={filters['spareParts'] && filters['spareParts']['schema'] && filters['spareParts']['schema']['sparePart'].options.main}
          model={filters['spareParts'] && filters['spareParts']['schema'] && filters['spareParts']['schema']['sparePart'].options.ref}
          initialValue={k && k.sparePart}
          onSelect={this.handleSparePartSelect.bind(this, index)}
          getFieldDecorator={getFieldDecorator}
          setFieldsValue={setFieldsValue}
        />

        {
          title === 'CREATE' && <Form.Item key={`${index}2`} label={'Available Quantity'}>
            {getFieldDecorator(`spareParts[${index}]['availableQuantity']`, {
              rules: [{required: false, message: `Available Quantity is required!`}],
              initialValue: ''
            })(<Input type='number'
                      placeholder={'0'}
                      disabled style={{marginRight: 8}}
                      onWheel={event => event.currentTarget.blur()}
            />)
            }
          </Form.Item>
        }

        <Form.Item key={`${index}3`} label={'Quantity'}>
          {getFieldDecorator(`spareParts[${index}]['quantity']`, {
            rules: [
              {required: true, message: `Quantity is required!`},
              {validator: this.validateQuantity(index)}
            ],
            initialValue: k.quantity,
          })(<Input type='number'
                    placeholder={'Quantity'}
                    style={{marginRight: 8}}
                    onWheel={event => event.currentTarget.blur()}
          />)
          }
        </Form.Item>

        {index > 0 ? (
          <Icon
            className="dynamic-delete-button"
            type="minus-circle-o"
            onClick={() => this.remove(index)}
          />
        ) : null}
      </div>
    });
  }

  fetchAssetListBySparePart(data) {
    this.setState({mainTableDataSource: []});
    this.props.fetchAssetListBySparePart(data);
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, subDocumentFilters, title, resource, form} = this.props;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {
              (title === 'EDIT') && <Form.Item key={'staNo'} label={'STA Number'}>
                {getFieldDecorator('staNo', {
                  rules: [{required: false, message: `STA Number is required!`}],
                  initialValue: ((data && data.staNo) || ''),
                })(<Input disabled/>)
                }
              </Form.Item>
            }

            <Row gutter={16}>
              <Col span={14}>
                <Form.Item key={'from.location'} label={'From Location'}>
                  {getFieldDecorator('from.location', {
                    rules: [{required: true, message: `From Location is required!`}],
                    initialValue: data && data.from && data.from.location && data.from.location._id,
                  })(<Select
                    showSearch
                    style={{width: '80%'}}
                    placeholder="Please select"
                    onSelect={this.handleFromLocationChange}
                    backfill={true}
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={(title === 'EDIT' && filters['from.location'] && filters['from.location'].options.disabledOnEdit) || false}
                  >
                    {filters['from.location'] && filters['from.location']['data'] && filters['from.location']['data']['data'].map(item => !item.isSystemGenerated &&
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                  {
                    filters['from.location'] && filters['from.location'].options && filters['from.location'].options.master ?
                      <MasterModal resource={resource} item={filters['from.location'].options.ref}
                                   title={'CREATE'}/> : ''
                  }
                </Form.Item>
              </Col>
              <Col span={14}>
                <Form.Item key={'from.client'} label={'From Sub Location'}>
                  {getFieldDecorator('from.client', {
                    rules: [{required: false, message: `From Sub Location is required!`}],
                    initialValue: data && data.from && data.from.client && data.from.client._id,
                  })(<Select
                    showSearch
                    allowClear
                    style={{width: '80%'}}
                    placeholder="Select From Sub Location"
                    onChange={this.handleFromClientChange}
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={(title === 'EDIT' && filters['from.client'] && filters['from.client'].options.disabledOnEdit) || false}
                  >
                    {filters['from.client'] && filters['from.client']['data'] && filters['from.client']['data']['data'].map(item => !item.isSystemGenerated &&
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                  {
                    filters['from.client'] && filters['from.client'].options && filters['from.client'].options.master ?
                      <MasterModal resource={resource} item={filters['from.client'].options.ref} title={'CREATE'}/> : ''
                  }
                </Form.Item>
              </Col>
            </Row>

            <Form.Item key={'dispatchedDate'} label={'Dispatched Date'}>
              {getFieldDecorator('dispatchedDate', {
                rules: [{required: true, message: `Dispatched Date is required!`}],
                initialValue: data && data.dispatchedDate && moment(data.dispatchedDate),
              })(<DatePicker showTime
                onChange={this.handleDispatchedDateChange}
                disabled={(title === 'EDIT' && filters['dispatchedDate'] && filters['dispatchedDate'].options.disabledOnEdit) || false}/>)
              }
            </Form.Item>

            {this.formItems()}
            <Form.Item>
              <Button type="dashed" onClick={this.add} style={{width: '60%', marginTop: '15px'}}>
                <Icon type="plus"/> Add {sanitizeFieldName('Spare Part')}
              </Button>
            </Form.Item>

            {/*{Object.keys(filters).map((item) => {*/}
            {/*  if (filters[item].type === 'Array' && filters[item].schema) {*/}
            {/*    return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title} resource={resource}/>*/}
            {/*  } else {*/}
            {/*  }*/}
            {/*})}*/}

            <Row gutter={16}>
              <Col span={14}>
                <Form.Item key={'to.location'} label={'To Location'}>
                  {getFieldDecorator('to.location', {
                    rules: [{required: true, message: `To Location is required!`}],
                    initialValue: data && data.to && data.to.location && data.to.location._id,
                  })(<Select
                    showSearch
                    style={{width: '80%'}}
                    placeholder="Please select"
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={(title === 'EDIT' && filters['to.location'] && filters['to.location'].options.disabledOnEdit) || false}
                  >
                    {filters['to.location'] && filters['to.location']['data'] && filters['to.location']['data']['data'].map(item =>
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                  {
                    filters['to.location'] && filters['to.location'].options && filters['to.location'].options.master ?
                      <MasterModal resource={resource} item={filters['to.location'].options.ref} title={'CREATE'}/> : ''
                  }
                </Form.Item>
              </Col>
              <Col span={14}>
                <Form.Item key={'to.client'} label={'To Sub Location'}>
                  {getFieldDecorator('to.client', {
                    rules: [{required: false, message: `To Sub Location is required!`}],
                    initialValue: data && data.to && data.to.client && data.to.client._id,
                  })(<Select
                    showSearch
                    allowClear
                    style={{width: '80%'}}
                    placeholder="Select To Sub Location"
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={(title === 'EDIT' && filters['to.client'] && filters['to.client'].options.disabledOnEdit) || false}
                  >
                    {filters['to.client'] && filters['to.client']['data'] && filters['to.client']['data']['data'].map(item =>
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                  {
                    filters['to.location'] && filters['to.location'].options && filters['to.location'].options.master ?
                      <MasterModal resource={resource} item={filters['to.location'].options.ref} title={'CREATE'}/> : ''
                  }
                </Form.Item>
              </Col>
            </Row>

            <Form.Item key={'modeOfTransport'} label={'Mode Of Transport'}>
              {getFieldDecorator('modeOfTransport', {
                rules: [{required: true, message: `Mode Of Transport is required!`}],
                initialValue: data && data.modeOfTransport,
              })(<Select
                placeholder={`Please select Mode Of Transport`}
                disabled={(title === 'EDIT' && filters['modeOfTransport'] && filters['modeOfTransport'].options.disabledOnEdit) || false}
              >
                {filters['modeOfTransport'] && filters['modeOfTransport'].options && filters['modeOfTransport'].options.enum && filters['modeOfTransport'].options.enum.map(item =>
                  <Select.Option key={item}
                                 value={item}>{item}</Select.Option>)}
              </Select>)
              }
            </Form.Item>

            {Object.keys(filters).map((item) => {
              if(item === 'transportationCost' || item === 'transporter') {
                return getFormFieldByType(filters, item, getFieldDecorator, data, {
                  resource,
                  title,
                  setFieldsValue: this.props.form.setFieldsValue
                })
              }
            })}

            <Form.Item key={'transportDetails'} label={'Transport Details'}>
              {getFieldDecorator('transportDetails', {
                rules: [{required: true, message: `Transport Details is required!`}],
                initialValue: data && data.transportDetails,
              })(<Input
                disabled={(title === 'EDIT' && filters['transportDetails'] && filters['transportDetails'].options.disabledOnEdit) || false}/>)
              }
            </Form.Item>
           
            <Form.Item key={'consignedBy'} label={'Consigned By'}>
              {getFieldDecorator('consignedBy', {
                rules: [{required: true, message: `Consigned By is required!`}],
                initialValue: data && data.consignedBy && data.consignedBy._id,
              })(<Select
                showSearch
                style={{width: '80%'}}
                placeholder="Please select"
                filterOption={(input, option) =>
                  (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                }
                disabled={(title === 'EDIT' && filters['consignedBy'] && filters['consignedBy'].options.disabledOnEdit) || false}
              >
                {filters['consignedBy'] && filters['consignedBy']['data'] && filters['consignedBy']['data']['data'].map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
              {
                filters['consignedBy'] && filters['consignedBy'].options && filters['consignedBy'].options.master ?
                  <MasterModal resource={resource} item={filters['consignedBy'].options.ref} title={'CREATE'}/> : ''
              }
            </Form.Item>

            <Form.Item key={'consignedTo'} label={'Consigned To'}>
              {getFieldDecorator('consignedTo', {
                rules: [{required: true, message: `Consigned To is required!`}],
                initialValue: data && data.consignedTo && data.consignedTo._id,
              })(<Select
                showSearch
                style={{width: '80%'}}
                placeholder="Please select"
                filterOption={(input, option) =>
                  (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                }
                disabled={(title === 'EDIT' && filters['consignedTo'] && filters['consignedTo'].options.disabledOnEdit) || false}
              >
                {filters['consignedTo'] && filters['consignedTo']['data'] && filters['consignedTo']['data']['data'].map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
              {
                filters['consignedTo'] && filters['consignedTo'].options && filters['consignedTo'].options.master ?
                  <MasterModal resource={resource} item={filters['consignedTo'].options.ref} title={'CREATE'}/> : ''
              }
            </Form.Item>

            <Form.Item key={'expectedDateOfDelivery'} label={'Expected Date Of Delivery'}>
              {getFieldDecorator('expectedDateOfDelivery', {
                rules: [{required: true, message: `Expected Date Of Delivery is required!`}],
                initialValue: data && data.expectedDateOfDelivery && moment(data.expectedDateOfDelivery),
              })(<DatePicker
                disabled={(title === 'EDIT' && filters['expectedDateOfDelivery'] && filters['expectedDateOfDelivery'].options.disabledOnEdit) || false}/>)
              }
            </Form.Item>

            <Row gutter={16}>
              <Col span={14}>
                <Form.Item key={'preparedBy.name'} label={'Prepared By Name'}>
                  {getFieldDecorator('preparedBy.name', {
                    rules: [{required: true, message: `Prepared By Name is required!`}],
                    initialValue: data && data.preparedBy && data.preparedBy.name && data.preparedBy.name._id,
                  })(<Select
                    showSearch
                    style={{width: '80%'}}
                    placeholder="Please select"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    disabled={(title === 'EDIT' && filters['preparedBy.name'] && filters['preparedBy.name'].options.disabledOnEdit) || false}
                  >
                    {filters['preparedBy.name'] && filters['preparedBy.name']['data'] && filters['preparedBy.name']['data']['data'].map(item =>
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                  {
                    filters['preparedBy.name'] && filters['preparedBy.name'].options && filters['preparedBy.name'].options.master ?
                      <MasterModal resource={resource} item={filters['preparedBy.name'].options.ref}
                                   title={'CREATE'}/> : ''
                  }
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item key={'preparedBy.date'} label={'Prepared By Date'}>
                  {getFieldDecorator('preparedBy.date', {
                    rules: [{required: true, message: `Prepared By Date is required!`}],
                    initialValue: data && data.preparedBy && data.preparedBy.date && moment(data.preparedBy.date),
                  })(<DatePicker
                    disabled={(title === 'EDIT' && filters['preparedBy.date'] && filters['preparedBy.date'].options.disabledOnEdit) || false}/>)}
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={14}>
                <Form.Item key={'approvedBy.name'} label={'Approved By Name'}>
                  {getFieldDecorator('approvedBy.name', {
                    rules: [{required: true, message: `Approved By Name is required!`}],
                    initialValue: data && data.approvedBy && data.approvedBy.name && data.approvedBy.name._id,
                  })(<Select
                    showSearch
                    style={{width: '80%'}}
                    placeholder="Please select"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    disabled={(title === 'EDIT' && filters['approvedBy.name'] && filters['approvedBy.name'].options.disabledOnEdit) || false}
                  >
                    {filters['approvedBy.name'] && filters['approvedBy.name']['data'] && filters['approvedBy.name']['data']['data'].map(item =>
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                  {
                    filters['approvedBy.name'] && filters['approvedBy.name'].options && filters['approvedBy.name'].options.master ?
                      <MasterModal resource={resource} item={filters['approvedBy.name'].options.ref}
                                   title={'CREATE'}/> : ''
                  }
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item key={'approvedBy.date'} label={'Approved By Date'}>
                  {getFieldDecorator('approvedBy.date', {
                    rules: [{required: true, message: `Approved By Date is required!`}],
                    initialValue: data && data.approvedBy && data.approvedBy.date && moment(data.approvedBy.date),
                  })(<DatePicker
                    disabled={(title === 'EDIT' && filters['approvedBy.date'] && filters['approvedBy.date'].options.disabledOnEdit) || false}/>)}
                </Form.Item>
              </Col>
            </Row>

            <Form.Item key={'remarks'} label={'Remarks'}>
              {getFieldDecorator('remarks', {initialValue: data && data.remarks})(<TextArea disabled={title === 'VIEW'}
                                                                                            rows={3}/>)}
            </Form.Item>
            {
              filters && filters.documents &&
              <DocumentList history={this.props.history} match={this.props.match} key={filters.documents}
                            item={filters.documents} form={form} data={data.documents}
                            subDocumentFilters={subDocumentFilters} getDocumentData={this.getDocumentData}
                            isDisabled={(title === 'EDIT' && filters['documents'] && filters['documents'].options.disabledOnEdit) || false}/>
            }

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}
                      disabled={this.props.title === 'EDIT' || false}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
          {this.renderBalancePopup()}
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
